import React from "react";
import { CarouselModal } from "@src/lms/jelly/extensions/layouts/_lesson/case7/common/components/CarouselModal";
import { useIntl } from "react-intl";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import * as appConfig from "appConfig";

import styles from "./BinauralMonitoring.module.scss";
import { useUi } from "@jelly/lesson";
import { messages } from "../../Workflow.messages";

type BinauralMonitoringModalProps = Omit<React.ComponentProps<typeof CarouselModal>, "children">;

export const BinauralMonitoringModal: React.FC<BinauralMonitoringModalProps> = (props) => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <ui.Modal {...props}>
      <div className={styles.slide}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
        <SpatialCarousel showBreadcrumbs controlsPosition="bottom">
          {[
            <div key={1} className={styles.carouselItem}>
              <div className={styles.content}>
                <h2 className={styles.title}>{formatMessage(messages.binauralMonitoringTitle)}</h2>
                <ui.Scrollbars>
                  <div className={styles.description}>
                    <p>{formatMessage(messages.binauralMonitoringDescription)}</p>
                  </div>
                </ui.Scrollbars>
              </div>
              <div className={styles.divider}></div>
              <img
                className={styles.image}
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/2.jpg`}
                alt="feature-comparison"
              />
            </div>,
            <div key={2} className={styles.carouselItem}>
              <div className={styles.content}>
                <h2 className={styles.title}>{formatMessage(messages.binauralMonitoringTitle)}</h2>
                <ui.Scrollbars>
                  <div className={styles.description}>
                    <p dangerouslySetInnerHTML={{ __html: formatMessage(messages.binauralMonitoringDescription2) }}></p>
                  </div>
                </ui.Scrollbars>
              </div>
              <div className={styles.divider}></div>
              <img
                className={styles.image}
                src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/workflow/3.jpg`}
                alt="feature-comparison"
              />
            </div>,
          ]}
        </SpatialCarousel>
      </div>
    </ui.Modal>
  );
};
